export enum E_HomeRotativeItemMode {
  Default = 'Default',
  Equitable = 'Equitable',
  FixedImageTime = 'FixedImageTime',
}